export default [
    {
        path: "/voucher/canteen/received",
        component: () => import("@/App/Canteen/Voucher/Received/Components/List.vue"),
        name: "voucher.canteen.received",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/received/create",
        component: () => import("@/App/Canteen/Voucher/Received/Components/Create.vue"),
        name: "voucher.canteen.received.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/received/emi",
        component: () => import("@/App/Canteen/Voucher/Received/Components/Emi.vue"),
        name: "voucher.canteen.received.emi",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/received/:id/edit",
        component: () => import("@/App/Canteen/Voucher/Received/Components/Edit.vue"),
        name: "voucher.canteen.received.edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/received/:id/view",
        component: () => import("@/App/Canteen/Voucher/Received/Components/View.vue"),
        name: "voucher.canteen.received.view",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/received/pre-sanction",
        component: () => import("@/App/Canteen/Voucher/Received/Components/PreSanction.vue"),
        name: "voucher.canteen.pre-sanction.received",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/received/bank-withdraw",
        component: () => import("@/App/Canteen/Voucher/Received/Components/Bank.vue"),
        name: "voucher.canteen.bank.withdraw",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/received/:id/note-sheet",
        component: () => import("@/App/Canteen/Voucher/Received/Components/NoteSheet.vue"),
        name: "voucher.canteen.note-sheet",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/received/:id/journal-note-sheet",
        component: () => import("@/App/Canteen/Voucher/Received/Components/JournalNoteSheet.vue"),
        name: "voucher.canteen.journal-note-sheet",
        meta: {
            requiresAuth: true,
        },
    },
];
